// Single source of truth for paid photobooth options — labels and prices.
// Frontend counterpart of /app/backend/options_catalog.py. Kept in sync.

export const OPTION_PRICES = {
  magnet_50: 50,
  magnet_100: 80,
  backdrop: 40,
};

export const OPTION_LABELS = {
  magnet_50: "Support Photo Aimanté (50 unités)",
  magnet_100: "Support Photo Aimanté (100 unités)",
  backdrop: "Fond pour Photos",
};

export const MAGNET_SIZE_LABELS = { "10x15": "10×15 cm", "5x15": "5×15 cm" };
export const MAGNET_COLOR_LABELS = { blanc: "Blanc", noir: "Noir" };

export const describeOption = (key, options = {}) => {
  const base = OPTION_LABELS[key] || key;
  if (key === "magnet_50" || key === "magnet_100") {
    const size = MAGNET_SIZE_LABELS[(options?.magnet_size || "").toLowerCase()];
    const color = MAGNET_COLOR_LABELS[(options?.magnet_color || "").toLowerCase()];
    const extras = [size, color].filter(Boolean);
    if (extras.length) return `${base} — ${extras.join(" — ")}`;
  }
  return base;
};

export const buildOptionRows = (options) => {
  if (!options) return [];
  return Object.entries(options)
    .filter(([k, v]) => v === true && OPTION_PRICES[k])
    .map(([k]) => ({ key: k, label: describeOption(k, options), price: OPTION_PRICES[k] }));
};

export const optionsPriceTotal = (options) => {
  if (!options) return 0;
  return Object.entries(options).reduce(
    (sum, [k, v]) => (v === true && OPTION_PRICES[k] ? sum + OPTION_PRICES[k] : sum),
    0
  );
};
